export default __webpack_public_path__ + "static/media/add_new_user_icon.ab0777b1.svg";